import { useDispatch, useSelector } from 'react-redux'
import { Waypoint } from 'react-waypoint'
import { fetchAirDna } from '../../../actions/airDna'
import { selectHasRequestDataMap } from '../../../store/selectors/airDna'
import { selectAddress, selectHomeId } from '../../../store/selectors/home'
import { AirDna } from '../../shared/AirDna'

export const HomeownerAirDna = () => {
  const dispatch = useDispatch()
  const homeId = useSelector(selectHomeId)
  const address = useSelector(selectAddress)
  const hasData = useSelector(selectHasRequestDataMap)[homeId]

  if (!homeId) return null

  return (
    <>
      <Waypoint onEnter={() => !hasData && dispatch(fetchAirDna(homeId,{ address: `${address.street} ${address.city}, ${address.state} ${address.zip}` }))} />
      <AirDna hideEdit stateKey={homeId} showNightlyRentals={false} locked={false} />
    </>
  )
}
